import React from 'react';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';

const StudentSignupForm = props => {
    return (
        <div className="inputPageContainer">
            <div className="inputPage">
                <h1>Student Signup</h1>
                <form onSubmit={props.handleSubmit}>
                    <div>
                        <div className="inputRow">
                            <SelectField
                                hintText={"School"}
                                name="school"
                                value={props.school}
                                onChange={props.handleDropdownChangeSchool}
                                iconStyle={{paddingLeft: "22px"}}
                            >
                                {props.schoolOptions}
                            </SelectField>
                        </div>
                        {props.school ? (
                            <div className="inputRow">
                                <SelectField
                                    hintText={"Class"}
                                    name="class"
                                    value={props.class}
                                    onChange={props.handleDropdownChangeClass}
                                    iconStyle={{paddingLeft: "22px"}}
                                >
                                    {props.classOptions}
                                </SelectField>
                            </div>
                        ) : null}
                    </div>
                    <TextField
                        hintText="First Name"
                        underlineShow={false}
                        name="firstName"
                        className="inputRow"
                        fullWidth={true}
                        onChange={props.handleChange}
                    />
                    <Divider />
                        <TextField
                            hintText="Last Name"
                            underlineShow={false}
                            name="lastName"
                            className="inputRow"
                            value={props.lastName}
                            fullWidth={true}
                            onChange={props.handleChange}
                        />
                    <Divider />
                        <TextField
                            hintText="Email address"
                            underlineShow={false}
                            className="inputRow"
                            fullWidth={true}
                            name="email"
                            value={props.email}
                            onChange={props.handleChange}
                            type="email"
                        />
                    <Divider />
                      <TextField
                          hintText="Student ID"
                          underlineShow={false}
                          className="inputRow"
                          fullWidth={true}
                          name="studentId"
                          value={props.studentId}
                          onChange={props.handleChange}
                      />
                    <Divider />
                        <TextField
                            hintText="Password"
                            underlineShow={false}
                            className="inputRow"
                            fullWidth={true}
                            type="password"
                            name="password"
                            value={props.password}
                            onChange={props.handleChange}
                    />
                    <Divider />
                    <button type="submit" className="pink">Sign Up</button>
                </form>
                <p className="errorMessage">{props.errMsg}</p>
            </div>
        </div>
    );
}

export default StudentSignupForm;
